<template>
    <div>
        <el-dialog v-model="addFamilyShow" :close-on-click-modal="false" title="" width="500" :show-close="false"
            :align-center="true">
            <template #header>
                <div class="header">{{ isEdit ? '信息资料' : '添加' }}</div>
                <div class="close_icon cursor_pointer" @click="closePopup">
                    <el-icon :size="24">
                        <Close />
                    </el-icon>
                </div>
            </template>
            <div class="dialog_content">
                <div class="flex Flexalign family_one mb-20" v-if="isEdit">
                    <div class="family_label">头像：</div>
                    <el-image class="family_avatar" :src="familyInfo.image"></el-image>
                </div>
                <div class="flex Flexalign family_one" v-if="relationshipOptions.length">
                    <div class="family_label">关系：</div>
                    <el-select v-model="familyInfo.familyId" placeholder="请选择关系" style="width: 300px" size="large"
                        :disabled="isEdit" @change="selectRelationShip">
                        <el-option v-for="item in relationshipOptions" :key="item.familyId" :label="item.familyName"
                            :value="item.familyId" />
                    </el-select>
                </div>
                <div class="flex Flexalign family_one mt-20">
                    <div class="family_label">手机号：</div>
                    <div class="flex Flexalign FlexBetween" style="width: 300px;">
                        <el-input v-model="familyInfo.phone" :style="{ width: `${isEdit ? '300px' : '220px'}` }"
                            size="large" placeholder="请输入手机号" :disabled="isEdit" type="number" @change="phoneChange" />
                        <div class="ml-20 cursor_pointer" @click="certificationPhone" v-if="!isEdit">
                            <el-button :type="isCertification ? 'info' : 'success'" class="btn_cert">{{ isCertification ? '已认证' : '认证'
                            }}</el-button>
                        </div>
                    </div>
                </div>
                <!-- <div class="flex Flexalign family_one mt-20">
                    <div class="family_label">姓名：</div>
                    <el-input v-model="familyInfo.name" style="width: 300px" size="large" placeholder="请输入姓名" />
                </div> -->
                <div class="flex Flexalign family_one mt-20">
                    <div class="family_label">称呼：</div>
                    <el-input v-model="familyInfo.nickName" style="width: 300px" size="large" placeholder="请输入称呼" />
                </div>
                <div class="btn cursor_pointer" @click="confirm">
                    {{ isEdit ? '解绑' : '确认绑定' }}
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "GjkcH5AddFamily",

    data() {
        return {
            addFamilyShow: false,
            familyInfo: {
                image: '',
                familyId: '',
                name: '',
                nickName: '',
                phone: '',
                sex: '',
            },
            // relationshipOptions: [
            // { label: '哥哥', value: 1 },
            // { label: '姐姐', value: 2 },
            // ],
            isEdit: false,
            isCertification: false,
            certificationInfo: {}, // 手机号查询的用户信息，用于判断用户是否存在
        };
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.userInfo,
            relationshipOptions: (state) => state.user.relationshipOptions,
        }),
    },

    mounted() {
        // this.getFamilyTree();
    },

    methods: {
        // 选择关系
        selectRelationShip() {
            let selectFamilyRelationship = this.relationshipOptions.filter(item => item.familyId == this.familyInfo.familyId)[0];
            this.familyInfo.nickName = selectFamilyRelationship.familyName;
            this.familyInfo.image = selectFamilyRelationship.image;
            this.familyInfo.sex = (this.userInfo.sex == "女"?0:1);
        },
        // 手机号变化需重新认证
        phoneChange() {
            this.isCertification = false;
        },
        //查询家庭关系
        getFamilyTree() {
            this.$Api.user.getFamilyTree({ userType: 2 }).then(res => {
                this.relationshipOptions = res.data.data;
            }).catch(() => { })
        },
        // 认证手机号
        certificationPhone() {
            if (this.$Tools.empty(this.familyInfo.phone)) {
                this.$Dialog.toast("手机号不能为空", { type: "warning" });
                return;
            }
            if (!/^1[345678]\d{9}$/.test(this.familyInfo.phone)) {
                this.$Dialog.toast("请输入正确的手机号", { type: "warning" });
                return;
            }
            this.$Api.user.searchFamilyByPhone({ phone: this.familyInfo.phone, relatedUserType: 1 }).then(res => {
                this.certificationInfo = res.data.data;
                // if(this.familyInfo.name){
                //     this.familyInfo.name = this.certificationInfo.name;
                // }
                if (!this.certificationInfo.buyerUserId) {
                    this.$Dialog.toast("当前手机号还不是会员，请确认是否注册", { type: "warning" });
                    return;
                }
                this.isCertification = true;
            }).catch(() => { })
        },
        closePopup() {
            this.addFamilyShow = false;
        },
        confirm() {
            if (!this.isCertification && !this.isEdit) {
                this.$Dialog.toast("请先认证手机号", { type: 'warning' });
                return
            }
            if (!this.familyInfo.familyId) {
                this.$Dialog.toast("请选择绑定的关系", { type: 'warning' });
                return
            }
            let selectFamilyRelationship = this.relationshipOptions.filter(item => item.familyId == this.familyInfo.familyId)[0];
            let familyInfo = {
                familyUserId: this.certificationInfo.buyerUserId,  // 绑定人用户id
                userId: this.userInfo.buyerUserId,  // 
                familyPid: selectFamilyRelationship.familyPid,
                familyId: selectFamilyRelationship.familyId,
                nickName: this.familyInfo.nickName,
                phone: this.familyInfo.phone,
                userPhone: this.userInfo.phone,
                image: this.familyInfo.image,
                userType: 2,  // 创建人类型1-家长，2-学生
                sex: this.familyInfo.sex,
                relatedUserType: 1,  // 关联的用户类型1-家长，2-学生
            };
            // 编辑修改逻辑
            if (this.isEdit) {
                this.$Dialog.confirm({
                    message: "确认要解绑该用户吗？",
                    title: "提示", // 可选，不传则使用默认值'确认'
                    onConfirm: () => {
                        this.$Api.user.delFamilyRelationship({ id: this.familyInfo.id }).then(() => {
                            this.$Dialog.toast("关系解绑成功");
                            this.$emit("refreshList");
                            this.closePopup();
                        })
                    }, // 确认后的操作，如调用删除API等
                    onCancel: () => {

                    },
                })
            } else {
                this.$Api.user.addFamily(familyInfo).then(() => {
                    this.$Dialog.toast('关系绑定成功');
                    this.$emit("refreshList");
                    this.closePopup();
                }).catch(() => { })
            }
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 20px 20px 10px 10px;
    padding: 0;
    width: 440px;
    background: #FFFFFF;
    border-radius: 10px;
}

:deep(.el-dialog__header) {
    position: relative;
}

.header {
    padding: 15px 20px;
    box-sizing: border-box;
    // text-align: center;
    font-weight: bold;
    font-size: 20px;
    color: #111111;
    // line-height: 60px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.close_icon {
    position: absolute;
    top: 20px;
    right: 20px;
}

.dialog_content {
    padding: 15px 20px;
    box-sizing: border-box;

    .family_one {
        .family_label {
            width: 80px;
        }

        .family_avatar {
            width: 60px;
            height: 60px;
            border-radius: 50%;
        }
        .btn_cert{
            background-color: #13d6aa;
            border: #13d6aa;
        }
    }

    .btn {
        width: 120px;
        height: 42px;
        background: linear-gradient(97deg, #00D498 0%, #00D5C2 100%);
        border-radius: 21px;
        margin: 20px auto 5px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
    }
}
</style>